<template>
  <div :class="['avue-echart-tabs', className]" :style="styleSizeName" ref="main">
    <div :style="styleChartName">
      <el-select
        v-if="isSelect"
        :style="styleSelectName"
        @change="handleSelectChange"
        v-model="active"
      >
        <el-option
          v-for="item in typeof optionTab === 'string' ? [] : optionTab"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div class="avue-echart-tabs__list" v-else>
        <div
          class="avue-echart-tabs__item"
          :style="[styleName, styleActiveName(item)]"
          v-for="(item, index) in optionTab"
          :key="index"
          @mouseenter="handleMouseEnter(item, index)"
          @mouseleave="handleMouseLeave(item, index)"
          @dblclick="handleDblClick(item, index)"
          @click="handleClick(item, index)"
        >
          <div
            v-if="item.icon"
            class="avue-echart-tabs__icon"
            :style="[
              styleIconName,
              styleIconBgName(item),
              styleIconActiveName(item),
            ]"
          ></div>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "yearMonthTab",
  data() {
    return {
      active: "",
      optionTab: [
        {
          label: "本月",
          value: "1"
        },
        {
          label: "本年",
          value: "2"
        }
      ],
    };
  },
  watch: {
    optionTab: {
      handler(val) {
        if (this.option?.activeValue === '1') {
          this.handleClick(val[0], 0, true);
        } else if (this.option?.activeValue === '2') {
          this.handleClick(val[1], 1, true);
        } else if (val && val.length){
          this.handleClick(val[0], 0, true);
        }
      },
      immediate: true,
    },
    componentsType(val, oldVal) {
      this.handleComponentsType(val)
    }
  },
  computed: {
    componentsType() {
      return this.option.componentsType
    },
    isSelect() {
      return this.type === "select";
    },
    type() {
      return this.option.type;
    },
    iconSize() {
      return this.option.iconSize || 20;
    },
    styleSelectName() {
      return Object.assign(
        {
          fontSize: this.setPx(this.option.fontSize || 30),
        },
        this.styleSizeName
      );
    },
    styleIconName() {
      return Object.assign({
        marginRight: this.setPx(this.option.iconSplit),
        width: this.setPx(this.option.iconSize),
        height: this.setPx(this.option.iconSize),
      });
    },
    styleName() {
      return Object.assign(
        (() => {
          if (this.option.backgroundImage) {
            return {
              backgroundImage: `url(${this.option.backgroundImage})`,
              backgroundSize: "100% 100%",
            };
          }
          return {};
        })(),
        {
          borderColor: this.option.borderColor || "#fff",
          borderStyle: "solid",
          borderWidth: this.setPx(this.option.borderWidth || 0),
          margin: `0 ${this.setPx(this.option.split)}`,
          backgroundColor: this.option.backgroundColor,
          fontSize: this.setPx(this.option.fontSize || 30),
          color: this.option.color,
        }
      );
    },
  },
  mounted() {
    if (this.option.componentsType) {
      this.handleComponentsType(this.option.componentsType)
    }
    if (this.option.activeValue) {
      this.active = this.option.activeValue
    }
  },
  methods: {
    handleComponentsType(val) {
      if (val === '30Day12Month') {
        this.optionTab = [
          {
            label: "近30天",
            value: "1"
          },
          {
            label: "近12个月",
            value: "2"
          }
        ]
      } else if (val === 'yearMonth') {
        this.optionTab = [
          {
            label: "本月",
            value: "1"
          },
          {
            label: "本年",
            value: "2"
          }
        ]
      }
    },
    styleIconBgName(item) {
      if (item.icon) {
        return {
          backgroundImage: `url(${item.icon})`,
          backgroundSize: "100% 100%",
        };
      }
    },
    styleIconActiveName(item) {
      if (this.active == item.value && item.empIcon) {
        return {
          backgroundImage: `url(${item.empIcon})`,
          backgroundSize: "100% 100%",
        };
      }
    },
    styleActiveName(item) {
      if (this.active == item.value) {
        return Object.assign(
          (() => {
            if (this.option.empBackgroundImage) {
              return {
                backgroundImage: `url(${this.option.empBackgroundImage})`,
                backgroundSize: "100% 100%",
              };
            }
            return {};
          })(),
          {
            borderColor: this.option.empBorderColor || "#fff",
            borderStyle: "solid",
            borderWidth: this.setPx(this.option.empBorderWidth || 0),
            color: this.option.empColor,
          }
        );
      }
    },
    handleSelectChange(value) {
      this.handleClick(value);
    },
    handleClick(item, index, target = false) {
      this.active = item.value;
      if (this.componentsType  === '30Day12Month' && this.currentLinkData) {
        this.handle30Day12MonthCheck(item)
      } else if (this.componentsType === 'yearMonth' && this.currentLinkData) {
        this.handleYearMonthCheck(item)
      }
      // this.handleCommonBind(item, index, "clickFormatter");
      // if (item.href && !target) window.open(item.href, item.target);
      
    },
    // 本年本月
    handleYearMonthCheck(item) {
      if (item.value === '1') {
        const month = new Date().getMonth() + 1
        Object.keys(this.currentLinkData).forEach(key => {
            if (key.indexOf('@month') >= 0) {
                this.currentLinkData[key].value = 'CURRENT_MONTH'
            } else if (key !== 'name') {
                this.currentLinkData[key].value = null
            }
        })
      } else if (item.value === '2') {
          const year = new Date().getFullYear()
          Object.keys(this.currentLinkData).forEach(key => {
              if (key.indexOf('@year') >= 0) {
                  this.currentLinkData[key].value = 'CURRENT_YEAR'
              } else if (key !== 'name') {
                  this.currentLinkData[key].value = null
              }
          })
      }
    },
    // 近30天近12个月
    handle30Day12MonthCheck(item) {
      if (item.value === '1') {
        Object.keys(this.currentLinkData).forEach(key => {
            if (key.indexOf('@day') >= 0) {
                this.currentLinkData[key].value = 'LAST_30_DAYS'
            } else if (key !== 'name') {
                this.currentLinkData[key].value = null
            }
        })
      } else if (item.value === '2') {
          Object.keys(this.currentLinkData).forEach(key => {
              if (key.indexOf('@month') >= 0) {
                  this.currentLinkData[key].value = 'LAST_12_MONTHS'
              } else if (key !== 'name') {
                  this.currentLinkData[key].value = null
              }
          })
      }
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
